import React, { useEffect, useRef, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import AccountScreen from './pages/account/AccountScreen';
import packageInfo from '../package.json';
import CacheBuster from 'react-cache-buster';
import Scan from './components/Scan';
import PageLoader from './components/loader/PageLoader';
import RedirectPage from './pages/RedirectPage';
import { ToastInternet } from './components/Toast';
import { toast } from 'react-toastify';
import CartScreen from './pages/CartScreen';
import {
  ACCOUNT,
  ADD_CB,
  ADD_FID_CARD,
  ADD_FID_SCAN,
  ADD_PAYMENT,
  BRAND,
  BRAND_DETAIL,
  CART,
  CHECK,
  COUPONS,
  EDENRED,
  FIDLOGIN,
  GIFT,
  HELP,
  HOME,
  INVITATION,
  LOGIN_FID_CARD,
  LOGIN_FID_SCAN,
  ORDER_SUCCESS,
  POPUP_PAYMENT,
  PRE,
  PRODUCT,
  PROMO,
  CONVERSION,
  RECOMPENSES,
  RESETPASSWORD,
  REWARD,
  SCAN,
  SCAN_CHECK,
  STORE_LIST,
  TICKETS,
  USER_FID_CARD,
  USER_FID_CARD_DETAIL,
  WALLET
} from './constants/routes';
import UserFidelityCard from './pages/account/fid/UserFidelityCard';
import UserFidelityCardDetail from './pages/account/fid/UserFidelityCardDetail';
import UserAddFidCardScreen from './pages/account/fid/add-card/UserAddFidCardScreen';
import UserAddFidScanScreen from './pages/account/fid/add-card/UserAddFidScanScreen';
import ProtectedRoute from './middleware/ProtectedRoute';

const PreScanScreen = React.lazy(() => import('./pages/PreScanScren'));
const StoreListScreen = React.lazy(() => import('./pages/StoreListScreen'))
const WelcomeScreen = React.lazy(() => import('./pages/WelcomeScreen'))


function App() {

  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const prevOnlineStatus = useRef(isOnline);

  useEffect(() => {
    const handleOnline = () => {
      if (!prevOnlineStatus.current) {
        toast.dismiss();
        ToastInternet('internet', 'connexion rétablie');
        setTimeout(() => {
          toast.dismiss();
        }, 2000);
      }
      setIsOnline(true);
      prevOnlineStatus.current = true;
    };

    const handleOffline = () => {
      setIsOnline(false);
      prevOnlineStatus.current = false;
      ToastInternet('noInternet', 'Aucune connexion internet');
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);
  // const location = useLocation();

  // console.log('hash', location.hash);
  window.scrollTo(0, 0);

  return (
    <CacheBuster currentVersion={packageInfo.version} isEnabled={true}>
      <BrowserRouter>
        <div className="home">
          <main>
            <React.Suspense fallback={<PageLoader />}>
              <Routes>
                <Route path="/" element={<RedirectPage />}></Route>
                <Route path={STORE_LIST} element={<StoreListScreen />} />
                <Route path={HOME} element={<WelcomeScreen />} />
                <Route path={PRE} element={<PreScanScreen />}></Route>
                <Route path={SCAN} element={
                  <ProtectedRoute>
                    <Scan />
                  </ProtectedRoute>
                }></Route>
                <Route path={ACCOUNT} element={<AccountScreen />}></Route>
              </Routes>
            </React.Suspense>
          </main>
        </div>
      </BrowserRouter>
    </CacheBuster>
  );
}

// git remote set-url origin https://github.com/lysot/Jilsfront.g
// npm install --legacy-peer-deps
export default App;
